import React, { useState, useEffect } from "react";
import { Alert, Snackbar } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { clearSuccessMessage } from "../../../actions/commonActions";
import { getSuccessMessage } from "../../../reducers";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const SuccessSnackbar = ({ successMessage }) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!open && successMessage) {
            setOpen(true);
        }
    }, [open, successMessage]);

    const handleClose = () => {
        clearSuccessMessage(dispatch);
        setOpen(false);
    };

    if (!successMessage) {
        return null;
    }

    return (
        <Snackbar
            open={open}
            onClose={handleClose}
            autoHideDuration={6000}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            sx={{ width: "50%" }}
        >
            <Alert
                onClose={handleClose}
                severity="success"
                data-cy="success-alert"
                sx={{ width: "100%", color: "#FFF" }}
                variant="filled"
                icon={<CheckCircleOutlineIcon fontSize="medium" />}
            >
                {successMessage}
            </Alert>
        </Snackbar>
    );
};

const mapStateToProps = (state) => ({
    successMessage: getSuccessMessage(state),
});

export default connect(mapStateToProps)(SuccessSnackbar);
